/**
 * Utility function to get the full image URL
 * In development, uses the backend URL directly to avoid proxy issues
 * In production, uses the relative path
 */
export const getImageUrl = (imagePath: string): string => {
  if (!imagePath) return '';
  
  // If the path already starts with http:// or https://, return it as is
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }
  
  // In development, use the full backend URL to avoid proxy issues
  if (process.env.NODE_ENV === 'development') {
    return `http://localhost:5001${imagePath}`;
  }
  
  // In production, use the relative path
  return imagePath;
};

